import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import config from '../../config';
import { useSelector, useDispatch } from 'react-redux';
import { setBookingField, showTeamMenu, showTimeMenu, unitMenu } from '../../store/ResourceStore';
import unitBook2Image from '../../images/radial_blue_right_top.png';
import unitBook5Image from '../../images/radial_blue_right_middel.png';
import unitBook8Image from '../../images/radial_blue_right_middel2.png';
import unitPlanImage from '../../images/radial_plan_right_bottom_turquoise2.png';

const Unit = (props) => {
    const dispatch = useDispatch();

    const resState = useSelector((state) => state.resourceState);

    const unit = props.unit;
    if(!unit) return null;

    const currentBooking = props.currentBooking;
    const unitMenuId = resState.unitMenuId;
    const nextBooking = props.nextBooking;
    const nextBookStart = nextBooking ? moment(nextBooking.startTime) : false;
    const currentBookingEnd = currentBooking && moment(currentBooking.endTime);

    let text = 'Ingen fremtidig booking fundet';
    if(currentBooking) text = `Booket indtil: ${currentBookingEnd.format('LLLL')} (${currentBookingEnd.fromNow()})`;
    else if(nextBooking) text = `${nextBookStart.format('LLLL')} (${nextBookStart.fromNow()})`;

    const renderUnitMenu = () => {
        const now = moment();
        const nowPlus2 = moment();
        const nowPlus5 = moment();
        const nowPlus8 = moment();
        const endOfDay = moment();
        const todayMorning = moment();
        const todayEvening = moment();
        nowPlus2.add(2, 'hours');
        nowPlus5.add(5, 'hours');
        nowPlus8.add(8, 'hours');
        endOfDay.endOf('day');
        todayMorning.hour(7).minute(0);
        todayEvening.hour(15).minute(0);
        return(
            <div className='unit-menu'>
                <div className='unit-book-2' onClick={() => {
                    dispatch(setBookingField({ field: 'unitId', value: unitMenuId }));                    
                    dispatch(setBookingField({ field: 'startTime', value: now.toISOString()}));
                    dispatch(setBookingField({ field: 'endTime', value: nowPlus2.toISOString()}));
                    dispatch(showTeamMenu(true));
                }}
                >
                    <img className='unit-book-image' src={unitBook2Image} alt={''}/>
                    <div className='unit-book-text'>Book 2 timer</div>

                </div>
                <div className='unit-book-5' onClick={() => {
                    dispatch(setBookingField({ field: 'unitId', value: unitMenuId }));                    
                    dispatch(setBookingField({ field: 'startTime', value: now.toISOString()}));
                    dispatch(setBookingField({ field: 'endTime', value: nowPlus5.toISOString()}));
                    dispatch(showTeamMenu(true));
                }}
                >
                    <img className='unit-book-image' src={unitBook5Image} alt={''}/>
                    <div className='unit-book-text'>Book 5 timer</div>

                </div>
                <div className='unit-book-8' onClick={() => {
                    dispatch(setBookingField({ field: 'unitId', value: unitMenuId }));                    
                    dispatch(setBookingField({ field: 'startTime', value: now.toISOString()}));
                    dispatch(setBookingField({ field: 'endTime', value: nowPlus8.toISOString()}));
                    dispatch(showTeamMenu(true));
                }}
                >
                    <img className='unit-book-image' src={unitBook8Image} alt={''}/>
                    <div className='unit-book-text'>Book 8 timer</div>

                </div>
                <div className='unit-plan' onClick={() => {
                    dispatch(setBookingField({ field: 'unitId', value: unitMenuId }));
                    dispatch(setBookingField({ field: 'startTime', value: todayMorning.toISOString() }));
                    dispatch(setBookingField({ field: 'endTime', value: todayEvening.toISOString() }));
                    dispatch(showTimeMenu(true));
                }}>
                    <img className='unit-plan-image' src={unitPlanImage} alt={''}/>
                    <div className='unit-plan-text'>Planlæg</div>
                </div>
            </div>
        )
    };

    return(
        <div className={`unit${currentBooking ? ' booked' : ''}`} onClick={() => dispatch(unitMenu({ unitId: unit.id, visible: unitMenuId !== unit.id }))}>            
        <img src={`${config.server}${unit.imagePath}`} alt=''/>
            <div className='unit-description'>
                {!props.hideName && <p className='unit-name'>{unit.name}</p>}
                {!props.hideText && <p>{text}</p>}
            </div>
            {!props.noMenu && unitMenuId === unit.id && renderUnitMenu()}
        </div>
    );
};


Unit.propTypes = {
    unit: PropTypes.object.isRequired,
    nextBooking: PropTypes.object,
    currentBooking: PropTypes.object,
    noMenu: PropTypes.bool,
    hideText: PropTypes.bool,
    hideName: PropTypes.bool
};

export default Unit;